export default __webpack_public_path__ + "static/media/warning--tunnel--g2.1ac74efb.png";